import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LessonState {
  selectedLessonId: string | null;
  filterSubject: string | null;
  filterDifficulty: string | null;
}

const initialState: LessonState = {
  selectedLessonId: null,
  filterSubject: null,
  filterDifficulty: null,
};

const lessonSlice = createSlice({
  name: 'lesson',
  initialState,
  reducers: {
    setSelectedLesson(state, action: PayloadAction<string | null>) {
      state.selectedLessonId = action.payload;
    },
    setLessonFilters(state, action: PayloadAction<{ subject?: string | null; difficulty?: string | null }>) {
      if (action.payload.subject !== undefined) state.filterSubject = action.payload.subject;
      if (action.payload.difficulty !== undefined) state.filterDifficulty = action.payload.difficulty;
    },
    clearLessonFilters(state) {
      state.filterSubject = null;
      state.filterDifficulty = null;
    },
  },
});

export const { setSelectedLesson, setLessonFilters, clearLessonFilters } = lessonSlice.actions;
export default lessonSlice.reducer;